import type { SvgIconProps } from './types/props.ts'

export const LinkedInIcon = (props: SvgIconProps) => {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      aria-hidden={true}
      role="img"
      {...props}
    >
      <g filter="url(#filter0_d_18503_203710)">
        <path
          d="M2.43164 7.99252C2.43164 4.68294 5.32873 2 8.90246 2H43.4135C46.9872 2 49.8843 4.68294 49.8843 7.99252V44.0075C49.8843 47.3171 46.9872 50 43.4135 50H8.90246C5.32873 50 2.43164 47.3171 2.43164 44.0075V7.99252Z"
          fill="#0077B5"
        />
      </g>
      <path
        d="M15.6372 18.252C17.5349 18.252 19.0732 16.7136 19.0732 14.8159C19.0732 12.9182 17.5349 11.3799 15.6372 11.3799C13.7395 11.3799 12.2012 12.9182 12.2012 14.8159C12.2012 16.7136 13.7395 18.252 15.6372 18.252Z"
        fill="white"
      />
      <path
        d="M25.111 20.0156V38.4031V20.0156ZM15.6387 20.0156V38.4031V20.0156Z"
        fill="white"
      />
      <path
        d="M25.111 20.0156V38.4031M15.6387 20.0156V38.4031"
        stroke="white"
        strokeWidth="6.12914"
      />
      <path
        d="M28.082 28.1882C28.082 26.3309 29.2893 24.4736 31.4252 24.4736C33.654 24.4736 34.4898 26.1451 34.4898 28.6525V38.4034H40.6189V27.9096C40.6189 22.2448 37.6472 19.6445 33.5611 19.6445C30.4037 19.6445 28.825 21.409 28.082 22.6162"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_18503_203710"
          x="0.431641"
          y="0"
          width="55.4531"
          height="56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="2" dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_18503_203710"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_18503_203710"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
